export default __webpack_public_path__ + "static/solutions-1bf351b9ee9e6c35f844f127dba387c9.png";